import type { FunctionComponent, LazyExoticComponent, ReactNode } from "react";

export type ProviderComponent =
  | FunctionComponent<{ children: ReactNode }>
  | LazyExoticComponent<FunctionComponent<{ children: ReactNode }>>;

export interface ProviderManagerProps {
  BaseProvider: ProviderComponent | null;
  PayPalProvider: ProviderComponent | null;
  children: ReactNode;
}

export function ProviderManager({
  BaseProvider,
  PayPalProvider,
  children,
}: ProviderManagerProps) {
  const initPaypalProvider =
    !!PayPalProvider &&
    !!import.meta.env.VITE_PAYPAL_CLIENT_ID &&
    import.meta.env.VITE_PAYPAL_CLIENT_ID.length > 0;

  if (BaseProvider && initPaypalProvider) {
    return (
      <BaseProvider>
        <PayPalProvider>{children}</PayPalProvider>
      </BaseProvider>
    );
  } else if (BaseProvider) {
    return <BaseProvider>{children}</BaseProvider>;
  } else if (initPaypalProvider) {
    return <PayPalProvider>{children}</PayPalProvider>;
  }

  throw new Error("Either BaseProvider or PayPalProvider must be provided");
}
